import PropTypes from 'prop-types';
import { Button, Stack } from '@etg/wings';
import { variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

const buttonStyles = css`
  width: calc(100% - 20px);

  @media ${mediaQueries.medium.up} {
    max-width: 360px;
  }
`;

const textStyles = css`
  font-size: 0.875rem;
`;

const ReviewModalFooter = ({ dispatch, form }) => {
  const { t } = useTranslation();

  return (
    <Stack align="center" data-testid="tdReviewInfo-footer" spacing={8}>
      <Stack align="center" className={textStyles} spacing={0}>
        <div data-testid="tdReviewInfo-footer-text">
          {t('TravelerDetails.Review.Modal.CheckCorrectInformation.Label')}
        </div>
        <div data-testid="tdReviewInfo-footer-subText">
          {t('TravelerDetails.Review.Modal.NoChangesAfterProceed.Label')}
        </div>
      </Stack>
      <Button
        className={buttonStyles}
        data-testid="bookNowModal-button"
        onClick={() => dispatch(submit(form))}
        variant={variants.PRIMARY}
      >
        {t('TravelerDetails.Review.Modal.CtaButton.Label')}
      </Button>
    </Stack>
  );
};

ReviewModalFooter.propTypes = {
  dispatch: PropTypes.func,
  form: PropTypes.string,
};

export default connect()(ReviewModalFooter);
